import { connect } from 'react-redux';

import { getBannersActiveAction } from '../actions/bannerAction';
import { loadDashboardHeaderInfo } from '../actions/dashboardActions';
import {
  getFriendRequestNotifications as getFriendRequestNotificationsAction,
  resolveFriendRequest,
  setResolveFriendRequestMessage,
  setResolveFriendRequestSuccess,
} from '../actions/MyFriendsActions';
import {
  getNotificationsMessages,
  notificationsMessagesSeenAction,
} from '../actions/notificationMessageAction';
import {
  getFriendRequestNotifications as getFriendRequestNotificationsSelector,
  getResolveFriendRequesSuccess,
  getResolveFriendRequestMessage,
  getResolveFriendRequesWaiting,
} from '../components/AccountSettings/MyFriends/MyFriendsSelectors';
import { bannersActive } from '../components/Banner/BannerSettingsSelectors';
import {
  getDashboardHeaderInfo,
  getDashboardHeaderInfoWaiting,
} from '../components/Dashboard/dashboardSelectors';
import CommonHeader from '../components/Headers/CommonHeader';
import {
  getNotificationsMessageSeenSelectors,
  getNotificationsMessageUnreadSelectors,
  loadNotificationSelectors,
} from '../components/NotificationMessage/NotificationMessageSelectors';

const mapStateToProps = (state) => ({
  notificationByFriend: getFriendRequestNotificationsSelector(state),
  userNotifications: getNotificationsMessageUnreadSelectors(state),
  userNotificationsSeen: getNotificationsMessageSeenSelectors(state),
  loadNotifications: loadNotificationSelectors(state),
  resolveFriendRequestWaiting: getResolveFriendRequesWaiting(state),
  resolveFriendRequestMessage: getResolveFriendRequestMessage(state),
  resolveFriendRequestSuccess: getResolveFriendRequesSuccess(state),
  dashboardHeaderInfo: getDashboardHeaderInfo(state),
  dashboardHeaderInfoWaiting: getDashboardHeaderInfoWaiting(state),
  bannersActive: bannersActive(state),
});

const mapDispatchToProps = (dispatch) => ({
  resolveFriendRequest: (id, status) =>
    dispatch(resolveFriendRequest(id, status)),
  setResolveFriendRequestMessage: (message) =>
    dispatch(setResolveFriendRequestMessage(message)),
  setResolveFriendRequestSuccess: (value) =>
    dispatch(setResolveFriendRequestSuccess(value)),
  loadDashboardHeaderInfo: () => dispatch(loadDashboardHeaderInfo()),
  getBannersActive: () => dispatch(getBannersActiveAction()),
  notificationsMessagesSeen: (notifications) =>
    dispatch(notificationsMessagesSeenAction(notifications)),
  getNotificationsMessages: (userId) =>
    dispatch(getNotificationsMessages(userId)),
  getFriendRequestNotifications: () =>
    dispatch(getFriendRequestNotificationsAction()),
});

const CommonHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommonHeader);

export default CommonHeaderContainer;
